export default function ColourChipLighting() {
    daylight();
    flourescent();
    energy();
}

const daylightButton = document.querySelector('.daylight'),
      flourescentButton = document.querySelector('.flourescent'),
      energyButton = document.querySelector('.energy'),
      daylightChip = document.querySelector('.daylight-chip'),
      flourescentChip = document.querySelector('.flourescent-chip'),
      energyChip = document.querySelector('.energy-chip'),
      allButtons = document.querySelectorAll('.light-selector'),
      allChips = document.querySelectorAll('.chip'),
      chipBrightness= document.querySelector('.colour-chip-brightness');

      var i;


function daylight() {
  if (daylightButton) {
    daylightButton.addEventListener("click", function() {
      for (i = 0; i < allButtons.length; i++) {
        allButtons[i].classList.remove("current");
      }

      for (i = 0; i < allChips.length; i++) {
        allChips[i].classList.remove("visible");
      }
        
      this.classList.add("current");
      daylightChip.classList.add("visible");
      chipBrightness.innerHTML = this.getAttribute("data-Daylight");

    });
  }
}

function flourescent() {
  if (flourescentButton) {
    flourescentButton.addEventListener("click", function() {
      for (i = 0; i < allButtons.length; i++) {
        allButtons[i].classList.remove("current");
      }

      for (i = 0; i < allChips.length; i++) {
        allChips[i].classList.remove("visible");
      }
      
      this.classList.add("current");
      flourescentChip.classList.add("visible");
      chipBrightness.innerHTML = this.getAttribute("data-fluorescent");

    });
  }
}

function energy() {
  if (energyButton) {
      energyButton.addEventListener("click", function () {

          for (i = 0; i < allButtons.length; i++) {
            allButtons[i].classList.remove("current");
          }

          for (i = 0; i < allChips.length; i++) {
            allChips[i].classList.remove("visible");
          }

          this.classList.add("current");
          energyChip.classList.add("visible");
          chipBrightness.innerHTML = this.getAttribute("data-energy");

    });
  }
}

